// extracted by mini-css-extract-plugin
export var container = "_9p-1";
export var cornerButtonContainer = "_9p-5";
export var disabled = "_9p-2";
export var fileContainer = "_9p-4";
export var hiddenInput = "_9p-3";
export var widthContainer = "_9p-0";